<template>
  <div class='mainContainer'>
    <div class='nav'>
      <el-form :model='searchForm' label-width='130px' :inline='true'>
        <el-form-item label='委托商：'>
          <el-input v-model='searchForm.consignorName' size='mini' placeholder='请输入委托商'/>
        </el-form-item>
        <el-form-item label='品牌：'>
          <el-input v-model='searchForm.brandName' size='mini' placeholder='请输入品牌'/>
        </el-form-item>
        <el-form-item label='计划时间：'>
          <!--          <el-date-picker
                      size='mini'
                      v-model='planDate'
                      value-format='yyyy-MM-dd'
                      type='date'
                      unlink-panels
                      range-separator='至'
                      start-placeholder='开始日期'
                      end-placeholder='结束日期'
                      :picker-options='pickerOptions'>
                    </el-date-picker>-->
          <el-date-picker v-model='searchForm.startPlanTime' size='mini' style='width:150px'
                          value-format='yyyy-MM-dd' @change='datePlanChange' type='date'
                          placeholder='开始日期'/>
          <span style='display:inline-block;width:15px;text-align:center;font-size:18px'>-</span>
          <el-date-picker v-model='searchForm.endPlanTime' size='mini' style='width:150px'
                          value-format='yyyy-MM-dd' @change='datePlanChange' type='date'
                          placeholder='结束日期'/>
        </el-form-item>
        <el-form-item label='交车时间：'>
          <!--          <el-date-picker
                      size='mini'
                      v-model='deliveryDate'
                      value-format='yyyy-MM-dd'
                      type='daterange'
                      unlink-panels
                      range-separator='至'
                      start-placeholder='开始日期'
                      end-placeholder='结束日期'
                      :picker-options='pickerOptions'>
                    </el-date-picker>-->
          <el-date-picker v-model='searchForm.startTime' size='mini' style='width:150px'
                          value-format='yyyy-MM-dd' @change='dateChange' type='date'
                          placeholder='开始日期'/>
          <span style='display:inline-block;width:15px;text-align:center;font-size:18px'>-</span>
          <el-date-picker v-model='searchForm.endTime' size='mini' style='width:150px'
                          value-format='yyyy-MM-dd' @change='dateChange' type='date'
                          placeholder='结束日期'/>
        </el-form-item>
        <el-form-item>
          <el-button size='small' style='margin-left: 10px;' class='searchBtn' @click='searchBtn'>
            查询
          </el-button>
          <el-button size='small' class='resetBtn' @click='resetBtn'>重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span='24' class='exportButton'>
        <span @click='exportData'>导出数据</span>
      </el-col>
    </el-row>
    <div class='content'>
      <el-table
        ref='registerTable'
        row-key='id'
        v-loading='tableLoading'
        :data='tableData'
        style='width: 100%'
        border
        :header-cell-style='headerCellStyle'
        @selection-change='selectionChange'
        :row-style="rowStyle"
      >
        <el-table-column type='selection' align='center' min-width='50'/>
        <el-table-column label='委托商' prop='consignorName' align='center'/>
        <el-table-column label='品牌' prop='brandName' align='center'/>
        <!--        <el-table-column label='交单编号' prop='brandName' align='center'/>
                <el-table-column label='交单日期' prop='brandName' align='center'/>
                <el-table-column label='交单人' prop='operationName' align='center'/>-->
        <el-table-column label='应交单数量' align='center'>
          <template slot-scope='scope'>
            <div style='color: #0aabf6' class='pointer' @click='btnClick("allInfo", scope.row)'>
              {{ scope.row.shouldCompleted }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label='未交单数量' align='center'>
          <template slot-scope='scope'>
            <div style='color: #0aabf6' class='pointer'
                 @click='btnClick("undeliveredInfo", scope.row)'>
              {{ scope.row.shouldCompleted - scope.row.actualCompleted }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class='paginationContainer'>
        <el-pagination
          background
          :page-sizes='[10, 20, 30, 40]'
          layout='total, sizes, prev, pager, next, jumper'
          :total='total'
          @size-change='contractSizeChange'
          @current-change='contractCurrentChange'
          :current-page.sync='searchForm.page'
          :page-size='searchForm.rows'
        />
      </div>
    </div>

    <!-- 详情 -->
    <delivery-report-info ref='deliveryReportInfoRef'/>
  </div>
</template>

<script>
import DeliveryReportInfo from './components/info';
import { getSessionStore } from '@/config/mUtils';
import { baseUrl } from '@/config/env';
import { deleteContract } from '@/service/contract';
import { receiptReportList } from '@/service/receipt';

export default {
  name: 'deliveryReport',
  components: {
    DeliveryReportInfo,
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          },
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          },
        }],
      },
      // planDate: ['', ''],
      // deliveryDate: ['', ''],
      searchForm: {
        consignorName: '',
        brandName: '',
        startTime: '',
        endTime: '',
        startPlanTime: '',
        endPlanTime: '',
        page: 1,
        rows: 10,
      },
      defaultSearchForm: {},
      tableLoading: false,
      tableData: [],
      headerCellStyle: {
        'color': '#3B3B3B',
        'font-size': '13px',
        'height': '48px',
        'background': '#E8E8E8',
      },
      total: 0,
      selectedData: []
    };
  },
  mounted() {
    this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
    // this.searchBtn();
  },
  methods: {
    // 结束时间
    datePlanChange(val) {
      if (this.searchForm.endPlanTime && this.searchForm.startPlanTime && this.compareDate(this.searchForm.startPlanTime, this.searchForm.endPlanTime)) {
        if (val == this.searchForm.endPlanTime) this.searchForm.endPlanTime = '';
        if (val == this.searchForm.startPlanTime) this.searchForm.startPlanTime = '';
        this.$forceUpdate();
        return this.$message.warning('结束日期必须大于开始日期！');
      }
    },
    // 结束时间
    dateChange(val) {
      if (this.searchForm.endTime && this.searchForm.startTime && this.compareDate(this.searchForm.startTime, this.searchForm.endTime)) {
        if (val == this.searchForm.endTime) this.searchForm.endTime = '';
        if (val == this.searchForm.startTime) this.searchForm.startTime = '';
        this.$forceUpdate();
        return this.$message.warning('结束日期必须大于开始日期！');
      }
    },
    compareDate(d1, d2) {
      return ((new Date(d1.replace(/-/g, '\/'))) > (new Date(d2.replace(/-/g, '\/'))));
    },
    btnClick(str, row) {
      switch (str) {
        case 'allInfo':
          this.$refs.deliveryReportInfoRef.dialogOpen(row, {
            ...this.searchForm,
            status: 0,
          });
          break;
        case 'undeliveredInfo':
          this.$refs.deliveryReportInfoRef.dialogOpen(row, {
            ...this.searchForm,
            status: 1,
          });
          break;
      }
    },
    // 查询
    searchBtn() {
      this.searchForm.page = 1;
      this.getTableData();
    },
    // 重置
    resetBtn() {
      this.searchForm = JSON.parse(JSON.stringify(this.defaultSearchForm));
      this.planDate = ['', ''];
      this.deliveryDate = ['', ''];
    },
    // 获取表格数据
    async getTableData() {
      this.tableLoading = true;
      const {
        status,
        message,
        data,
      } = await receiptReportList({
        ...this.searchForm,
        startTime: this.searchForm.startTime||'',
        endTime: this.searchForm.endTime||'',
        startPlanTime: this.searchForm.startPlanTime||'',
        endPlanTime: this.searchForm.endPlanTime||'',
      });
      this.tableLoading = false;
      if (status !== 0) return this.$message.warning(message);
      this.tableData = data.records;
      this.total = data.total;
    },
    contractSizeChange(row) {
      this.searchForm.rows = row;
      this.searchForm.page = 1;
      this.getTableData();
    },
    contractCurrentChange(page) {
      this.searchForm.page = page;
      this.getTableData();
    },
    selectionChange(selectionRow) {
      this.selectedData = selectionRow;
    },
    rowStyle({ row }) {
      return this.selectedData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
    },
    // 导出数据
    exportData() {
      // let token = getSessionStore('token');
      // window.location.href = `${baseUrl}/platform/receiptManage/exportReceiptReport?access_token=${token}&consignorName=${this.searchForm.consignorName}&brandName=${this.searchForm.brandName}&startTime=${this.searchForm.startTime ? this.searchForm.startTime : ''}&endTime=${this.searchForm.endTime ? this.searchForm.endTime : ''}&startPlanTime=${this.searchForm.startPlanTime ? this.searchForm.startPlanTime : ''}&endPlanTime=${this.searchForm.endPlanTime ? this.searchForm.endPlanTime : ''}`;
      window.exportExcelGet('/platform/receiptManage/exportReceiptReport', `consignorName=${this.searchForm.consignorName}&brandName=${this.searchForm.brandName}&startTime=${this.searchForm.startTime ? this.searchForm.startTime : ''}&endTime=${this.searchForm.endTime ? this.searchForm.endTime : ''}&startPlanTime=${this.searchForm.startPlanTime ? this.searchForm.startPlanTime : ''}&endPlanTime=${this.searchForm.endPlanTime ? this.searchForm.endPlanTime : ''}`);
    },
  },
};
</script>


<style lang='scss' scoped>
.mainContainer {
  width: 100%;
  padding: 20px 15px 0 15px;
  background-color: #fff;

  .nav {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    &Btn {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
  }

  .content {
    .paginationContainer {
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-top: 10px;

      span {
        font-size: 13px;
      }
    }
  }
}
</style>
